import { createAction } from 'redux-actions';
import callApi from '../../util/apiCaller';

// Action creators
export const fetchUserSessionsRequest = createAction('FETCH_USER_SESSIONS_REQUEST');
export const fetchUserSessionsSuccess = createAction('FETCH_USER_SESSIONS_SUCCESS');
export const fetchUserSessionsFailure = createAction('FETCH_USER_SESSIONS_FAILURE');

export const revokeSessionRequest = createAction('REVOKE_SESSION_REQUEST');
export const revokeSessionSuccess = createAction('REVOKE_SESSION_SUCCESS');
export const revokeSessionFailure = createAction('REVOKE_SESSION_FAILURE');

export const revokeAllOtherSessionsRequest = createAction('REVOKE_ALL_OTHER_SESSIONS_REQUEST');
export const revokeAllOtherSessionsSuccess = createAction('REVOKE_ALL_OTHER_SESSIONS_SUCCESS');
export const revokeAllOtherSessionsFailure = createAction('REVOKE_ALL_OTHER_SESSIONS_FAILURE');

// Fetch user's sessions
export function fetchUserSessions() {
  return async dispatch => {
    dispatch(fetchUserSessionsRequest());

    try {
      const response = await callApi(dispatch, 'auth/sessions/all', null, 'GET');
      // Extract sessions array from response object
      const sessions = response.sessions || [];
      dispatch(fetchUserSessionsSuccess(sessions));
      return sessions;
    } catch (error) {
      dispatch(fetchUserSessionsFailure(error));
      throw error;
    }
  };
}

// Revoke a specific session
export function revokeSession(sessionId) {
  return async dispatch => {
    dispatch(revokeSessionRequest({ sessionId }));

    try {
      await callApi(dispatch, `auth/sessions/${sessionId}/revoke`, null, 'POST');
      dispatch(revokeSessionSuccess({ sessionId }));

      // Refresh the sessions list
      dispatch(fetchUserSessions());
    } catch (error) {
      dispatch(revokeSessionFailure({ sessionId, error }));
      throw error;
    }
  };
}

// Revoke all other sessions (except current)
export function revokeAllOtherSessions() {
  return async dispatch => {
    dispatch(revokeAllOtherSessionsRequest());

    try {
      await callApi(dispatch, 'auth/sessions/revoke-others', null, 'POST');
      dispatch(revokeAllOtherSessionsSuccess());

      // Refresh the sessions list
      dispatch(fetchUserSessions());
    } catch (error) {
      dispatch(revokeAllOtherSessionsFailure(error));
      throw error;
    }
  };
}
